<div *ngIf="page" id="page">
	<!-- <h2 [innerHtml]="page.title.rendered" class="text-center"></h2> -->
	<div style="text-align: center; margin-top: -1.5rem; padding-top: 2.5rem;">
		<img src="/assets/editor-head.png" *ngIf="api.currentUrl.indexOf('/pages/FAR') === 0 && !api.export" width="250" class="m-auto">
	</div>
	<div [innerHtml]="page.html" class="entry-content" ></div>
</div>